import { Injectable, Type } from "@angular/core";

import {
  PRIMITIVE,
  ClientMessageBrokerFactory,
  ClientMessageBroker,
  FnArg,
  FnTransferableArg,
  UiArguments,
} from "shared/provider-webworker";

import { TradeDealLookupService } from "./TradeDealLookupService";
import { ReplicaBlotterLookupService } from "../../impl/ReplicaBlotterLookupService";
import { IBasePrimeDependent } from "../../IBasePrimeDependent";
import { ITradeDealPromiseLookupService } from "../ITradeDealPromiseLookupService";
import { BaseLookupService } from "../../impl/BaseLookupService";
import { PromiseLookupService } from "../../impl/PromiseLookupService";

import * as CubiqTS from "shared/cubiq-model-multi-asset";
import { LoggerService } from "@bfx/logger";
const logger = LoggerService.for(__dirname);

@Injectable()
export class TradeDealReplicaLookupService
  extends ReplicaBlotterLookupService<string, CubiqTS.DealImpl>
  implements ITradeDealPromiseLookupService
{
  constructor(protected factory: ClientMessageBrokerFactory) {
    super(factory, CubiqTS.DealImpl, "DealImpl", CubiqTS.DealImpl);
  }

  startUpdates(): void {}

  getTradeDeal(dealId: string): Promise<CubiqTS.DealImpl> {
    let request = new UiArguments("getTradeDeal");
    let arg1 = new FnArg(dealId, PRIMITIVE);
    request.args = [arg1];
    return this.broker.runOnService(request, this.VALUE);
  }

  getAllTradeDeals(): Promise<Array<CubiqTS.DealImpl>> {
    let request = new UiArguments("getAllTradeDeals");
    request.args = [];
    return this.broker.runOnService(request, this.VALUE);
  }

  protected getModelUpdateEventType(): Type<CubiqTS.ConcreteEncodable> {
    return CubiqTS.DealImpl;
  }
}
